import { render, staticRenderFns } from "./AdministrationApplicationDetails.vue?vue&type=template&id=354087c0&scoped=true&"
import script from "./AdministrationApplicationDetails.vue?vue&type=script&lang=js&"
export * from "./AdministrationApplicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationApplicationDetails.vue?vue&type=style&index=0&id=354087c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354087c0",
  null
  
)

export default component.exports